import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#1F2A24] text-white pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          <div>
            <div className="mb-5">
              <img
                src="/logo.svg"
                alt="Ravintola La Maria"
                className="h-14 w-auto brightness-0 invert opacity-90"
              />
            </div>
            <p className="text-white/70 leading-relaxed text-sm">{t.footer.tagline}</p>
          </div>

          <div>
            <h4 className="font-serif text-[#D4A94B] text-xs tracking-[0.25em] uppercase mb-4">{t.contact.address}</h4>
            <div className="space-y-3 text-sm">
              <div className="flex gap-3 items-start">
                <MapPin size={16} className="text-[#D4A94B] mt-0.5 shrink-0" />
                <div className="text-white/80">Kalustetie 1<br />01720 Vantaa</div>
              </div>
              <div className="flex gap-3 items-center">
                <Phone size={16} className="text-[#D4A94B] shrink-0" />
                <a href="tel:+358407611347" className="text-white/80 hover:text-[#D4A94B] transition-colors">040 7611347</a>
              </div>
              <div className="flex gap-3 items-center">
                <Mail size={16} className="text-[#D4A94B] shrink-0" />
                <a href="mailto:info@ravintolalamaria.fi" className="text-white/80 hover:text-[#D4A94B] transition-colors break-all">info@ravintolalamaria.fi</a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-serif text-[#D4A94B] text-xs tracking-[0.25em] uppercase mb-4">{t.info.hoursTitle}</h4>
            <div className="space-y-2 text-sm">
              <div className="flex gap-3 items-center">
                <Clock size={16} className="text-[#D4A94B] shrink-0" />
                <div className="text-white/80">
                  <div>{t.info.weekdays} <span className="text-white/60">8–18</span></div>
                  <div>{t.info.weekend} <span className="text-white/60">— {t.info.closed}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {year} Ravintola La Maria. {t.footer.rights}</p>
          <p className="text-white/30">Kalustetie 1, Vantaa</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
